var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"landing-title"},[_c('div',{staticClass:"landing-title__text-wrapper"},[_c('h1',{staticClass:"landing-title__title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }